export const adventureComponentTypes = {
  adventures: 'adventures',
  camps: 'camps',
  charters: 'charters',
  kidsAdv: 'kids-adventures',
  kidsInt: 'kids-intensive',
}